import { ApiSuccess, IApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { ApiSaveSuccess } from "./baseService";
import { Base } from "ui/Scripts/source/framework/base";
import { EventList } from "../event/eventList";
import { EventEdit } from "../event/eventEdit";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { UserListItem } from "../user/userListItem";
import { GetEventDefaultHandlersResponse } from "../event/getEventDefaultHandlersResponse";
import { postApiCall, getApiCall, postEndlessListApiCall, getFileApiCall } from "./tokenService";
import { UnlockResult } from "../common/unlockResult";

export interface ISaveEventSuccess extends IApiSuccess {
    id: string;
    notifications: string;
}

export class SaveEventSuccess implements ISaveEventSuccess {
    id: string;
    message: string;
    errorMessage: string;
    notifications: string;

    constructor();
    constructor(obj: ISaveEventSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.message = obj && obj.message || "";
        this.errorMessage = obj && obj.errorMessage || "";
        this.notifications = obj && obj.notifications || "";
    }
}

export const getEventList =
    (page: number, state: number, startDate: number, endDate: number, unitId: string): Promise<EventList> => {
        return getApiCall<EventList>("api/event?page=" + page +
            "&state=" + (!Base.isNullOrUndefined(state) ? state : "") +
            "&startDate=" + (!Base.isNullOrUndefined(startDate) ? startDate : "") +
            "&endDate=" + (!Base.isNullOrUndefined(endDate) ? endDate : "") +
            "&unitId=" + (!Base.isNullOrUndefined(unitId) ? unitId : ""), EventList);
    };

export const eventListRefresh =
    (page: number, state: number, startDate: number, endDate: number, unitId: string): Promise<EventList> => {
        return getApiCall<EventList>("api/event/refresh?page=" + page +
            "&state=" + (!Base.isNullOrUndefined(state) ? state : "") +
            "&startDate=" + (!Base.isNullOrUndefined(startDate) ? startDate : "") +
            "&endDate=" + (!Base.isNullOrUndefined(endDate) ? endDate : "") +
            "&unitId=" + (!Base.isNullOrUndefined(unitId) ? unitId : ""), EventList);
    };

export const getEventEdit = (id: string): Promise<EventEdit> => {
    return getApiCall<EventEdit>("api/event/item?id=" + id, EventEdit);
};

export const saveEvent = (obj: any): Promise<SaveEventSuccess> => {
    return postApiCall<SaveEventSuccess>("api/event/save", SaveEventSuccess, JSON.stringify(obj));
};

export const emailEvent = (id: string, notifications: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/event/email", ApiSuccess, JSON.stringify({ id, notifications }));
};

export const removeEvent = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/event/remove?id=" + id, ApiSuccess);
};

export const printEvent = (id: string, name: string): Promise<string> => {
    return getFileApiCall("api/event/print?id=" + id + "&name=" + name);
};

export const getUserList = (unitId: string, page: number, ignoreUserCodes: string[]): Promise<IEndlessList<UserListItem>> => {
    return postEndlessListApiCall<UserListItem>("api/event/user", UserListItem, JSON.stringify({ unitId, page, ignoreUserCodes }));
};

export const getEventDefaultHandlers = (companyId: string, unitId: string, isNewEvent: boolean): Promise<GetEventDefaultHandlersResponse> => {
    return getApiCall<GetEventDefaultHandlersResponse>("api/event/defaulthandler?id=" + companyId + "&unitId=" + (!Base.isNullOrEmpty(unitId) ? unitId : "") + "&isNewEvent=" + isNewEvent, GetEventDefaultHandlersResponse);
};

export const getLocked = (id: string): Promise<boolean> => {
    return getApiCall<boolean>("api/event/getlocked?id=" + id, null);
};

export const unlock = (id: string, lockToCurrentUser: boolean): Promise<UnlockResult> => {
    return postApiCall<UnlockResult>(
        "api/event/unlock?id=" + id + "&lockToCurrentUser=" + (lockToCurrentUser ? "true" : "false"),
        UnlockResult);
};

export const saveEventMessage = (obj: any): Promise<ApiSaveSuccess> => {
    return postApiCall<ApiSaveSuccess>("api/eventmessage/save", ApiSaveSuccess, JSON.stringify(obj));
};

export const approveEvent = (obj: any): Promise<ApiSaveSuccess> => {
    return postApiCall<ApiSaveSuccess>("api/eventhandler/approve", ApiSaveSuccess, JSON.stringify(obj));
};

export const sendEventReadReceipt = (id: string): Promise<ApiSuccess> => {
    return postApiCall("api/event/sendreadreceipt?id=" + id, ApiSuccess);
};